import React from 'react'

import NKIcon from '@norkart/ikoner'
import { UserManager } from 'oidc-client'
import { resolve } from '../dependencies'

const LogoutButton = () => {

    const logout = (e) => {
        e.preventDefault()
        window.sessionStorage.removeItem('bruker')
        resolve(UserManager).signoutRedirect()
    }

    return (
        <li>
            <a href="#login" style={{textDecoration: 'none' }} onClick={logout}>

            Logg ut
                <span className="pull-right">
                    <NKIcon icon="logg-ut" size="1" color="nk-white" />
                </span>
            </a>
        </li>
    )
}


export default LogoutButton


// WEBPACK FOOTER //
// ./src/felles/logoutbutton.jsx